import * as React from 'react';
import { Chat as IconChat } from '../../Icons/';
import { IHeaderV1Schema } from '../../../repositories/header/entities/response/HeaderV1Schema';
import { Icon } from '../Icon';
import { mapSectionToCategory } from '../../../mappers/mapSectionToCategory';
import { ca } from '@cian/analytics';

export interface IChatsNotificatorProps {
  headerData: IHeaderV1Schema;
  baseUrl: string | undefined;
  notificationsCount: number | null;
  section?: string | null;
}

export class NewChatsNotificator extends React.Component<IChatsNotificatorProps> {
  public render() {
    const { baseUrl, notificationsCount } = this.props;

    const count = Number(notificationsCount);
    const linkUrl = `${baseUrl}/dialogs/`;

    return (
      <Icon onClick={this.handleClick} iconView={<IconChat />} link={linkUrl} notifications={count} title="Сообщения" />
    );
  }

  private handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const { headerData } = this.props;

    if (!headerData.isAuthenticated) {
      event.preventDefault();

      window.waitForLoginPopup('chats');
    } else {
      ca('event', {
        name: 'oldevent',
        category: mapSectionToCategory(this.props.section),
        action: 'top_menu',
        label: 'messages',
      });
    }
  };
}
